var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AfterViewInit, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { FormBuilder, Validators } from "@angular/forms";
import { NotifyService } from "../../../services/notify.service";
import { PaymentService } from "../../../services/payment.service";
import { AgentData } from "../../../model/agent-page-data";
import { ActivatedRoute } from "@angular/router";
export class AgentPayComponent {
    constructor(formBuilder, notifyService, paymentService, renderer, route) {
        this.formBuilder = formBuilder;
        this.notifyService = notifyService;
        this.paymentService = paymentService;
        this.renderer = renderer;
        this.route = route;
        this.amount = 100;
        this.cardMask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/,];
        this.cvvMask = [/\d/, /\d/, /\d/, /\d/];
        this.triedSubmit = false;
        this.submitted = false;
        this.applePayAvailable = false;
        this.formSending = false;
        this._testPay = false;
    }
    set agent(agent) {
        this._agent = agent;
    }
    get agent() {
        return this._agent;
    }
    ngAfterViewInit() {
        this.amountChanged();
        // if ((window as any).ApplePaySession) {
        //   console.log("Apple Session exists");
        //   const button = this.renderer.createElement('button');
        //   this.renderer.setAttribute(this.but.nativeElement, 'buttonstyle', 'black');
        //   this.renderer.setAttribute(this.but.nativeElement, 'type', 'buy');
        //   this.renderer.setAttribute(this.but.nativeElement, 'locale', 'en');
        //   this.renderer.setStyle(this.but.nativeElement, 'display', 'inline-bloc', RendererStyleFlags2.Important);
        //   this.renderer.appendChild(this.but.nativeElement, button);
        // } else {
        //   console.log("Apple Session not exists");
        // }
    }
    makeYearsList() {
        this.cardExpirationYearsList = new Array(17).fill(null).map((item, index) => new Date().getFullYear() + index);
    }
    amountChanged() {
        // if  (this._testPay === false) {
        //   return;
        // }
        // usa e-pay Apple Pay
        // Instantiate Client with Public API Key
        this.client = new usaepay.Client('uipWyMh85A7kkO4d79vrQ08bh5Q9f0ye4yg10Ha6ok');
        // this.client = new usaepay.Client('rFF392aBNn452F94JT7w083Ds94UnJz65cDcV83OoQ');
        if (!this.client) {
            this.notifyService.error('Usa pay client not initialized');
            return;
        }
        // this.notifyService.warn('Usa pay client initialized');
        let applePayConfig = {
            targetDiv: 'applePayContainer',
            displayName: 'Capsule Corp.',
            paymentRequest: {
                lineItems: [
                    {
                        label: 'shipping',
                        amount: this._finalAmount,
                        type: 'final'
                    },
                    {
                        label: 'subtotal',
                        amount: this._finalAmount,
                        type: 'final'
                    },
                    {
                        label: 'tax',
                        amount: this._finalAmount,
                        type: 'final'
                    }
                ],
                total: {
                    label: 'Capsule Corp.',
                    amount: this._finalAmount,
                    type: 'final'
                },
                countryCode: 'US',
                currencyCode: 'USD'
            }
        };
        // Instantiate ApplePay Entry
        this.applePay = this.client.createApplePayEntry(applePayConfig);
        if (!this.applePay) {
            this.notifyService.warn('ApplePay Entry didn\'t created');
        }
        // check to see if Apple Pay is available
        this.applePay.checkCompatibility().then(res => {
            // if so, add the Apple Pay button
            this.applePay.addButton();
            // this.notifyService.warn(' Apple Pay is  available Usa pay ');
        }).catch(err => {
            // if not, hide the section it would have gone into
            console.error(' Apple Pay is not available Usa pay: ', err);
            // this.notifyService.warn(' Apple Pay is not available Usa pay ');
            document.getElementById('applePayContainer').innerHTML = '';
        });
        // listen for Apple Pay to be successfully completed
        this.applePay.on('applePaySuccess', () => {
            // once successfully completed, payment key is ready
            // this.notifyService.warn(' once successfully completed, payment key is ready');
            this.client.getPaymentKey(this.applePay).then(result => {
                // this.notifyService.warn(' Try to handle Apple Pay');
                this.paymentKeyHandler(result);
            }).catch(res => {
                console.error('CATCH: ', res);
                this.notifyService.error(' Apple Pay with Usa Pay failed');
            });
        });
        // listen for Apple Pay to be successfully completed
        this.applePay.on('applePayPaymentAuthorized', () => {
            // once successfully completed, payment key is ready
            // this.notifyService.warn(' once Authorized completed, payment key is ready');
            this.client.getPaymentKey(this.applePay).then(result => {
                // this.notifyService.warn(' Try to handle Apple Pay');
                this.paymentKeyHandler(result);
            }).catch(res => {
                console.error('CATCH: ', res);
                this.notifyService.error('Apple Pay with Usa Pay failed');
            });
        });
        // listen for any Apple pay errors
        this.applePay.on('applePayError', () => {
            this.notifyService.warn('Usa pay  Apple Pay error triggered');
        });
        // listen for any Apple pay errors
        this.applePay.on('applePayPermissionDenied', () => {
            this.notifyService.warn('Usa pay  Apple Pay permission denied triggered');
        });
        // listen for any Apple pay errors
        this.applePay.on('applePayMerchantValidated', () => {
            this.notifyService.warn('Usa pay  Apple Pay Merchant Validated triggered');
        });
        // listen for any Apple pay errors
        this.applePay.on('applePaySessionCancel', () => {
            this.notifyService.warn('Usa pay  Apple Pay Cancelled');
        });
    }
    ngOnInit() {
        this.makeYearsList();
        this.lastExpirationYear = this.cardExpirationYearsList[this.cardExpirationYearsList.length - 1];
        this.paymentForm = this.formBuilder.group({
            name: ['', [Validators.required]],
            email: ['', [Validators.required, Validators.email]],
            card: ['', Validators.required],
            year: ['', Validators.required],
            month: ['', Validators.required],
            cvv: ['', Validators.required]
        });
        this.paymentForm.get('year').setValue(this.lastExpirationYear.toString());
        this.paymentForm.get('month').setValue('1');
        // if (window.ApplePaySession) {
        //   var merchantIdentifier = 'merchant.com.wholesale-flights';
        //   var promise = window.ApplePaySession.canMakePaymentsWithActiveCard(merchantIdentifier);
        //
        //   promise.then( (canMakePayments) => {
        //     if (canMakePayments) {
        //       console.log('Display Apple Pay button here.');
        //
        //       this.applePayAvailable = true;
        //     }
        //   });
        // }
        this.route.queryParams.subscribe(params => {
            if (params['test']) {
                this._testPay = true;
            }
        });
    }
    onApplePayClick() {
        // this.payUsingUsaPay();
    }
    pay() {
        this.triedSubmit = true;
        if (this.paymentForm.invalid === true) {
            this.notifyService.warn('Please fill all required fields', { timeout: 5000 });
            return;
        }
        this.agentTip = Object.assign({}, this.paymentForm.value, { amount: this._finalAmount, agentEmail: this._agent.email, agentName: this._agent.fullName });
        this.formSending = true;
        this.paymentService.submitTip(this.agentTip).subscribe(response => {
            if (response && response.status === 'SUCCESSFUL') {
                this.submitted = true;
                this.triedSubmit = false;
                this.paymentForm.reset();
                this.paymentForm.get('year').setValue(this.lastExpirationYear.toString());
                this.paymentForm.get('month').setValue('1');
                this.formSending = false;
                setTimeout(() => { this.submitted = false; }, 10000);
            }
            else {
                this.notifyService.error('Payment failed ', { timeout: 5000 });
                this.formSending = false;
            }
        }, error => {
            this.notifyService.error('Payment failed ' + error, { timeout: 5000 });
            this.formSending = false;
        });
    }
    // private payUsingUsaPay() {
    //
    //
    //
    // }
    paymentKeyHandler(token) {
        this.agentTip = Object.assign({}, this.paymentForm.value, { amount: this._finalAmount, agentEmail: this._agent.email, agentName: this._agent.fullName, paymentKey: token });
        this.formSending = true;
        this.paymentService.submitTip(this.agentTip).subscribe(response => {
            if (response && response.status === 'SUCCESSFUL') {
                this.submitted = true;
                this.triedSubmit = false;
                this.paymentForm.reset();
                this.paymentForm.get('year').setValue(this.lastExpirationYear.toString());
                this.paymentForm.get('month').setValue('1');
                this.formSending = false;
                setTimeout(() => { this.submitted = false; }, 10000);
            }
            else {
                this.notifyService.error('Payment failed ', { timeout: 5000 });
                this.formSending = false;
            }
        }, error => {
            this.notifyService.error('Payment failed ' + error, { timeout: 5000 });
            this.formSending = false;
        });
    }
    payUsingApplePay() {
        console.log('On Apple Pay Clicked');
        // Define ApplePayPaymentRequest
        const request = {
            "countryCode": "US",
            "currencyCode": "USD",
            "merchantCapabilities": ["supports3DS"],
            "supportedNetworks": ["visa", "masterCard", "amex", "discover"],
            "total": { "label": "Tip For Agent", "type": "final", "amount": "1.00" }
        };
        // this.paymentService.loadApplePaySession('https://apple-pay-gateway.apple.com/paymentservices/startSession')
        //   .then((response) =>  {
        //     this.notifyService.warn('Session created');
        //     session.completeMerchantValidation(response);
        //     this.notifyService.warn('Validation completed');
        //   }, error => {
        //     this.notifyService.warn('Failed to create session ' + error);
        //   });
        // Create ApplePaySession
        const session = new window.ApplePaySession(3, request);
        session.onvalidatemerchant = (event) => __awaiter(this, void 0, void 0, function* () {
            // if (event && event.validationURL) {
            //   // Call your own server to request a new merchant session.
            //   this.notifyService.warn('Inside On Validate Merhant. Validation Url: ' + event.validationURL);
            // } else {
            //   // Call your own server to request a new merchant session.
            //   this.notifyService.warn('Inside On Validate Merhant');
            // }
            // this.paymentService.loadApplePaySession(event.validationURL)
            this.paymentService.loadApplePaySession('https://apple-pay-gateway.apple.com/paymentservices/paymentSession')
                .then((response) => {
                this.notifyService.warn('Session created');
                session.completeMerchantValidation(response);
                this.notifyService.warn('Validation completed');
            }, error => {
                this.notifyService.warn('Failed to create session ' + error);
            });
        });
        session.onpaymentmethodselected = (event) => {
            this.notifyService.warn('onpaymentmethodselected');
            // Define ApplePayPaymentMethodUpdate based on the selected payment method.
            // No updates or errors are needed, pass an empty object.
            const update = { newTotal: { "label": "Tip For Agent", "type": "final", "amount": this._finalAmount } };
            session.completePaymentMethodSelection(update);
            // const email = event.paymentMethod.billingContact.emailAddress;
            this.notifyService.warn('onpaymentmethodselected complete ' + event.paymentMethod.billingContact);
        };
        session.onshippingmethodselected = (event) => {
            this.notifyService.warn('onshippingmethodselected');
            // Define ApplePayShippingMethodUpdate based on the selected shipping method.
            // No updates or errors are needed, pass an empty object.
            const update = {};
            session.completeShippingMethodSelection(update);
            console.log('onshippingmethodselected');
        };
        session.onshippingcontactselected = (event) => {
            console.log('onshippingcontactselected');
            this.notifyService.warn('onshippingcontactselected');
            // Define ApplePayShippingContactUpdate based on the selected shipping contact.
            const update = {
                status: 'STATUS_SUCCESS',
                newShippingMethods: {
                    "label": "Free Shipping",
                    "detail": "Arrives in 5 to 7 days",
                    "amount": this._finalAmount,
                    "identifier": "FreeShip"
                },
                newTotal: {
                    "label": "Free Shipping",
                    "amount": this._finalAmount,
                    "type": "final"
                },
                newLineItems: [{
                        "label": "Free Shipping",
                        "amount": this._finalAmount,
                        "type": "final"
                    }]
            };
            session.completeShippingContactSelection(update);
        };
        session.onpaymentauthorized = (event) => {
            this.notifyService.warn('Called onpaymentauthorized');
            if (event) {
                this.notifyService.warn('Event  ' + event);
                this.notifyService.warn('Payment  ' + event.payment);
            }
            else {
                this.notifyService.warn('Event  is undefined');
            }
            // Define ApplePayPaymentAuthorizationResult
            this.paymentService.authorize(event.payment.token).then((response) => {
                console.log("response from datatrans received");
                this.notifyService.warn(response.toString());
                if (response.toString().match(/status=.error./)) {
                    console.log("an error occured!");
                    console.log(response);
                    return session.abort();
                }
                const result = {
                    "status": window.ApplePaySession.STATUS_SUCCESS
                };
                session.completePayment(result);
                this.submitted = true;
                setTimeout(() => { this.submitted = false; }, 10000);
                this.notifyService.warn('Token  ' + JSON.stringify(event.token));
            }, error => {
                this.notifyService.warn('Failed to handle authorize event  ' + error.statusText);
                session.abort();
            });
            this.notifyService.warn('Token  ' + JSON.stringify(event));
        };
        session.oncancel = (event) => {
            if (event && event.sessionError) {
                this.notifyService.warn('Session cancelled ' + event.sessionError.code + event.sessionError.info.toString(), { timeout: 10000 });
            }
            else {
                this.notifyService.warn('Session cancelled by unknown reasons', { timeout: 10000 });
            }
            // Payment cancelled by WebKit
            console.log('Payment cancelled by WebKit' + event.sessionError.code);
        };
        session.begin();
    }
    validateMerchant(url) {
        return fetch("https://apple-pay-gateway.apple.com/paymentservices/paymentSession", {
            // Adding method type
            method: "POST",
            // Adding body or contents to send
            body: JSON.stringify({
                merchantIdentifier: "merchant.com.wholesale-flights",
                displayName: "TipForAgent",
                initiative: "web",
                initiativeContext: "www.wholesale-flights.com"
            }),
            // Adding headers to the request
            headers: {
                "Content-type": "application/json; charset=UTF-8"
            }
        });
    }
    get testPay() {
        return this._testPay;
    }
    get _finalAmount() {
        return this._testPay ? 1 : this.amount;
    }
}
